import { Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { ResponsiveLayoutService } from 'src/app/services/responsive-layout.service';
import { PlantAdmin } from 'src/app/models/plant';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdminTableComponent } from 'src/app/shared/admin-table/admin-table.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-plants',
  templateUrl: './plants.component.html',
  styleUrls: ['./plants.component.css']
})
export class PlantsComponent implements OnInit {
  data$!: string;
  mapHeader = {
    id: { display: '#', data: null },
    code: { display: 'Código', data: null },
    name: { display: 'Nombre', data: null },
    carga_incompleta_value: { display: 'Valor Carga Incompleta', data: null },
    latitud: { display: 'Latitud', data: null },
    longitud: { display: 'Longitud', data: null },
    region: { display: 'Región', data: null },
    activa: { display: 'Estado', data: (data: any) => data.activa ? 'Activa' : 'Inactiva' },
    up: { display: 'UP Codigo', data: null },
    distancia_max: { display: 'Distancia Máxima', data: null },
    actions: {
      display: 'Acciones',
      sort: false,
      data: () => {
        return `<button class="btn btn-link btn-edit">
                    <svg class="bi" width="20" height="20" fill="currentColor">
                        <use xlink:href="assets/img/bootstrap-icons.svg#pencil-square" />
                    </svg>
                </button>`;
      },
      edit: (data: any) => { this.edit(data); }
    },
  };
  @ViewChild('table') table!: AdminTableComponent<PlantAdmin>;
  @ViewChild('content', { static: true }) content!: ElementRef;

  form!: FormGroup;
  constructor(
    private readonly injector: Injector,
    private readonly fb: FormBuilder,
    private readonly modalService: NgbModal,
    private readonly spinner: NgxSpinnerService,
    private readonly toastService: ToastService,
    private readonly storeService: StoreService,
    public responsiveService: ResponsiveLayoutService) {
  }

  ngOnInit(): void {
    this.data$ = 'plant/';
    this.initForm({});
  }

  initForm(el: any) {
    this.form = this.fb.group({
      id: [el?.id, [Validators.required]],
      code: [el?.code, [Validators.required]],
      name: [el?.name, [Validators.required]],
      carga_incompleta_value: [el?.carga_incompleta_value, [Validators.required]],
      latitud: [el?.latitud, [Validators.required]],
      longitud: [el?.longitud, [Validators.required]],
      region: [el?.region, [Validators.required]],
      activa: [el?.activa, [Validators.required]],
      up: [el?.up, [Validators.required]],
      distancia_max: [el?.distancia_max, [Validators.required]],
    });
  }

  edit(ele: any) {
    this.form.reset(ele);

    this.modalService.open(this.content, { centered: true });
  }

  save() {
    if (this.form.valid) {
      this.spinner.show();
      this.storeService.put_plants(this.form.value).subscribe({
        next: () => {
          this.toastService.showAdminSuccess('Se ha actualizado correctamente los datos');
          this.modalService.dismissAll();
          this.spinner.hide();
          this.table.reload();
        },
        error: () => {
          this.toastService.showAdminError('Por favor revise los datos');
          this.spinner.hide();
        }
      });
    }
  }
}
